import React from "react";
import { Card, Skeleton, Typography } from "antd";
import { formatPriceNoDecimal } from "helper/common";
import "./OrderStatsWidgets.scss";

const { Title, Text } = Typography;

const getPercent = (current = 0, previous = 0) => {
  if (!previous && !current) return 0;
  if (!previous && current > 0) return 100;
  return Math.round(((current - previous) / previous) * 100);
};

const GiftStatCard = ({ title, value, percent, isAmount, showPercent = false, loading = false }) => {
  const percentValue = Number(percent || 0);
  const percentClass = percentValue >= 0 ? "text-success" : "text-error";

  return (
    <Card bodyStyle={{ width: "100%", padding: 0 }} className="order-stats-widget-card">
      <div className="order-stats-widget-content">
        <div className="gift-stat-content">
          <Title level={5} className="order-stats-widget-title">
            {title}
          </Title>
          <div className="gift-stat-value-row">
            {loading ? (
              <Skeleton.Input active size="small" style={{ width: 120 }} />
            ) : (
              <>
                <Title className="text-primary order-stats-widget-value" level={3}>
                  {isAmount ? `${formatPriceNoDecimal(value || 0)}đ` : value || 0}
                </Title>
                {showPercent && (
                  percent !== null && percent !== undefined ? (
                    <Text className={percentClass}>
                      {percentValue >= 0 ? "+" : ""}{percentValue}%
                    </Text>
                  ) : (
                    <Text className={percentClass}>N/A</Text>
                  )
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Card>
  );
};

const GiftOrderStatsWidgets = ({ giftStats = {}, loading = false }) => {
  const currentMonthGiftAmount = giftStats.currentMonthGiftAmount || 0;
  const previousMonthGiftAmount = giftStats.previousMonthGiftAmount || 0;
  const currentMonthGiftCount = giftStats.currentMonthGiftCount || 0;
  const previousMonthGiftCount = giftStats.previousMonthGiftCount || 0;

  return (
    <div className="order-stats-widget-container">
      <GiftStatCard
        title="Tổng tiền đã tặng tháng này"
        value={currentMonthGiftAmount}
        percent={giftStats.giftAmountPercent ?? getPercent(currentMonthGiftAmount, previousMonthGiftAmount)}
        isAmount
        showPercent
        loading={loading}
      />
      <GiftStatCard
        title="Tổng tiền đã tặng tháng trước"
        value={previousMonthGiftAmount}
        isAmount
        loading={loading}
      />
      <GiftStatCard
        title="Số lượng quà tặng tháng này"
        value={currentMonthGiftCount}
        percent={giftStats.giftCountPercent ?? getPercent(currentMonthGiftCount, previousMonthGiftCount)}
        showPercent
        loading={loading}
      />
      <GiftStatCard
        title="Số lượng quà tặng tháng trước"
        value={previousMonthGiftCount}
        loading={loading}
      />
    </div>
  );
};

export default GiftOrderStatsWidgets;
